export default class Chart_class {
  constructor(label = 'class_label', value = 50, min, max) {
    this.label = label
    this.value = value
    this.min = min
    this.max = max
  }
}
